export default {
  '/editor': {
    name: 'editor',
    meta: {
      'zh-CN': {
        title: '无为'
      }
    },
    component: () =>
      import(/* webpackChunkName: "editor" */ '../../views/editor/index.vue'),
    children: [
      {
        name: 'editor_home',
        path: '/editor/home',
        meta: {
          'zh-CN': {
            title: '无为功能'
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "editor_app" */ '../../views/editor/app/index.vue'
          )
      }
    ]
  },
  '/inner': {
    name: 'inner',
    meta: {
      'zh-CN': {
        title: '无为'
      }
    },
    component: () =>
      import(/* webpackChunkName: "editor" */ '../../views/editor/index2.vue'),
    children: [
      {
        name: 'inner_home',
        path: '/inner/home',
        meta: {
          'zh-CN': {
            title: '无为功能'
          }
        },
        component: () =>
          import(
            /* webpackChunkName: "editor_app" */ '../../views/editor/app2/index.vue'
          )
      }
    ]
  },
  '/': {
    name: 'project',
    meta: {
      'zh-CN': {
        title: '添加项目'
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "editor" */ '../../views/editor/project/index.vue'
      )
  },
  '/version': {
    name: 'version',
    meta: {
      'zh-CN': {
        title: '版本管理'
      }
    },
    component: () =>
      import(
        /* webpackChunkName: "version" */ '../../views/editor/projectVersion/index.vue'
      )
  },
  '/census': {
    name: 'version',
    meta: {
      'zh-CN': {
        title: '数据查看'
      }
    },
    component: () => import(/* webpackChunkName: "version" */ '../../views/other/census/index.vue')
  },
  '/components': {
    name: 'components',
    meta: {
      'zh-CN': {
        title: '组件库'
      }
    },
    component: () => import(/* webpackChunkName: "version" */ '../../views/editor/components/index.vue')
  }
}
